import { DateRange } from 'react-day-picker';
import { DateRangePicker } from '@/Domain/components/Shared/DateRangePicker/DateRangePicker';
import { DateRangeState } from '@/Domain/types/DateRange.types';

interface DateRangeControlsProps {
  range: DateRangeState;
  onRangeChange: (range: DateRange | undefined) => void;
  maxRangeDays?: number;
}

export const DateRangeControls = ({
  range,
  onRangeChange,
  maxRangeDays,
}: DateRangeControlsProps) => (
  <DateRangePicker
    initialRange={{ from: range.startDate, to: range.endDate }}
    onRangeChange={onRangeChange}
    showPresets
    numberOfMonths={2}
    maxRangeDays={maxRangeDays}
  />
);
